import Loader from 'Root/Loader'

const Loading = () => (
  <div className="p-10">
    <Loader className="h-6 w-6 mx-auto text-indigo-600" />
  </div>
)

export default Loading
